import { render } from "./cat.vue?vue&type=template&id=6d6392f8"
import script from "./cat.vue?vue&type=script&lang=js"
export * from "./cat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__